import { Alert } from '@mui/material';

interface Props {
  message: string;
}

export default function ServerErrorAlert({ message }: Props) {
  return message && <Alert severity="error">{message}</Alert>;
}
